import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

/**
 * Global loader/spinner state.
 *
 * Uses BehaviorSubject so any subscriber that registers *after* a request
 * fires still receives the current loading state immediately.
 * distinctUntilChanged prevents redundant renders when consecutive HTTP
 * calls both set the loader to true.
 */
@Injectable({ providedIn: 'root' })
export class LoaderService {
  private readonly loader = new BehaviorSubject<boolean>(false);

  setLoader(state: boolean): void {
    this.loader.next(state);
  }

  getLoader(): Observable<boolean> {
    return this.loader.asObservable().pipe(distinctUntilChanged());
  }
}
